module.exports = __webpack_public_path__ + "static/media/pa.ee292674.svg";